<template>
  <div class="servers-configurator__sort-list">
    <template v-for="(item, i) in setterSortTypes">
      <label
        v-if="!$nuxt.$breakpoints.sLg"
        :key="i"
        class="servers-configurator__sort-item"
        :class="{'servers-configurator__sort-item--active' : hasActiveClass(item), 'servers-configurator__sort-item--hidden' : item.type === 'default'}"
      >
        <input
          type="checkbox"
          :checked="item.direction ? currentSortType === item.direction.up : false"
          :value="item.direction ? item.direction.up : 'default'"
          name="sort-type"
          @change="changeSortType($event, item)"
        >
        <span>
          {{ item.title }}
        </span>
        <svg-arrow
          v-show="item.direction ? currentSortType === item.direction.up || currentSortType === item.direction.down : false"
          class="servers-configurator__sort-item-icon"
          :class="{'servers-configurator__sort-item-icon--down' : item.direction ? currentSortType === item.direction.down : false}"
        ></svg-arrow>
      </label>

      <template v-else>
        <template v-if="item.direction">
          <template v-for="direction in item.direction">
            <label
              :key="direction"
              class="servers-configurator__sort-item"
              :class="{'servers-configurator__sort-item--active' : currentSortType === direction}"
            >
              <input
                type="checkbox"
                :checked="currentSortType === direction"
                :value="direction"
                name="sort-type"
                @change="changeSortType($event, item)"
              >
              <span>
                {{ item.title }}
                <span
                  v-if="direction === item.direction.up"
                  v-html="ordering.up"
                ></span>
                <span
                  v-else
                  v-html="ordering.down"
                ></span>
              </span>
              <svg-arrow
                v-show="currentSortType === direction"
                class="servers-configurator__sort-item-icon"
                :class="{'servers-configurator__sort-item-icon--down' : direction === item.direction.down}"
              ></svg-arrow>
            </label>
          </template>
        </template>
        <template v-else>
          <label
            :key="i"
            class="servers-configurator__sort-item"
            :class="{'servers-configurator__sort-item--active' : hasActiveClass(item), 'servers-configurator__sort-item--hidden' : item.type === 'default'}"
          >
            <input
              type="checkbox"
              :checked="item.direction ? currentSortType === item.direction.up : false"
              :value="item.direction ? item.direction.up : 'default'"
              name="sort-type"
              @change="changeSortType($event, item)"
            >
            <span>
              {{ item.title }}
            </span>
          </label>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import SvgArrow from '~/assets/icons/arrow-up.svg'

const sortTypesShort = {
  ru: [
    {
      type: 'vCpu',
      title: 'по количеству ядер',
      shortTitle: 'По ядрам',
      direction: {
        up: 'vCpuUp',
        down: 'vCpuDown'
      }
    },
    {
      type: 'ram',
      title: 'по объему памяти',
      shortTitle: 'По памяти',
      direction: {
        up: 'ramUp',
        down: 'ramDown'
      }
    },
    {
      type: 'cost',
      title: 'по стоимости',
      shortTitle: 'По цене',
      direction: {
        up: 'costUp',
        down: 'costDown'
      }
    }
  ],
  en: [
    {
      type: 'vCpu',
      title: 'by Cores',
      shortTitle: 'by Cores',
      direction: {
        up: 'vCpuUp',
        down: 'vCpuDown'
      }
    },
    {
      type: 'ram',
      title: 'by Memory',
      shortTitle: 'by Memory',
      direction: {
        up: 'ramUp',
        down: 'ramDown'
      }
    },
    {
      type: 'cost',
      title: 'by Price',
      shortTitle: 'by Price',
      direction: {
        up: 'costUp',
        down: 'costDown'
      }
    }
  ]
}

const sortTypes = {
  ru: [
    {
      type: 'default',
      title: 'по умолчанию',
      shortTitle: 'По умолчанию',
      direction: null
    },
    {
      type: 'vCpu',
      title: 'по количеству ядер',
      shortTitle: 'По ядрам',
      direction: {
        up: 'vCpuUp',
        down: 'vCpuDown'
      }
    },
    {
      type: 'ram',
      title: 'по объему памяти',
      shortTitle: 'По памяти',
      direction: {
        up: 'ramUp',
        down: 'ramDown'
      }
    },
    {
      type: 'cost',
      title: 'по стоимости',
      shortTitle: 'По цене',
      direction: {
        up: 'costUp',
        down: 'costDown'
      }
    }
  ],
  en: [
    {
      type: 'default',
      title: 'default',
      shortTitle: 'default',
      direction: null
    },
    {
      type: 'vCpu',
      title: 'by Cores',
      shortTitle: 'by Cores',
      direction: {
        up: 'vCpuUp',
        down: 'vCpuDown'
      }
    },
    {
      type: 'ram',
      title: 'by Memory',
      shortTitle: 'by Memory',
      direction: {
        up: 'ramUp',
        down: 'ramDown'
      }
    },
    {
      type: 'cost',
      title: 'by Price',
      shortTitle: 'by Price',
      direction: {
        up: 'costUp',
        down: 'costDown'
      }
    }
  ]
}

export default {
  name: 'DedicatedConfigurationsSortingItem',
  components: {
    SvgArrow
  },
  props: {
    currentSortType: {
      type: String,
      required: true,
      default: 'default'
    },
    isSale: {
      type: Boolean,
      default: false
    },
    isChipcore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sortTypesShort,
      sortTypes
    }
  },
  computed: {
    setterSortTypes() {
      if (this.isSale || this.isChipcore) {
        return this.sortTypesShort[this.$i18n.locale]
      } else {
        return this.sortTypes[this.$i18n.locale]
      }
    },
    ordering() {
      const names = {
        en: {
          up: '(ascending&nbsp;order)',
          down: '(descending&nbsp;order)'
        },
        ru: {
          up: '(по&nbsp;возрастанию)',
          down: '(по&nbsp;убыванию)'
        }
      }

      return names[this.$i18n.locale]
    }
  },
  methods: {
    hasActiveClass(sortType) {
      if (sortType.direction) {
        return this.currentSortType === sortType.direction.up || this.currentSortType === sortType.direction.down
      } else if (this.currentSortType === 'default') {
        return true
      } else {
        return false
      }
    },
    changeSortType(evt, item) {
      const selectedSortType = {
        type: 'default',
        title: item.title,
        shortTitle: item.shortTitle,
        direction: null
      }

      if (item.direction) {
        selectedSortType.direction = Object.keys(item.direction)
          .find(key => item.direction[key] === evt.target.value)

        if (this.$nuxt.$breakpoints.sLg) {
          selectedSortType.type = evt.target.value
        } else {
          selectedSortType.type = evt.target.checked
            ? item.direction.up
            : item.direction.down

          // TODO через Object.keys
          selectedSortType.direction = evt.target.checked
            ? 'up'
            : 'down'
        }
      } else {
        selectedSortType.type = evt.target.value
      }

      this.$emit('changeSortType', selectedSortType)
    }
  }
}
</script>